import React from 'react';
import PropTypes from 'prop-types';

import { get } from 'dpl/shared/utils/object';
import FullPageQuizQuestion, {
  FULL_PAGE_QUIZ_QUESTION_VARIANTS
} from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';
import { OPTION_GROUP_VARIANTS } from 'dpl/quiz/option_group/utils/constants';
import OptionGroup from 'dpl/quiz/option_group/components/OptionGroup';
import OptionGroupOption from 'dpl/quiz/option_group/components/OptionGroupOption';

const INPUT_NAME = 'children_count';

const options = [
  ...Array.from(new Array(4), (_, idx) => ({
    title: `${idx + 1}`,
    value: `${idx + 1}`
  })),
  {
    title: '5+',
    value: '5+'
  }
];

export default function QuizChildrenCountQuestion({
  formState,
  handleNextClick,
  onChange,
  isValid
}) {
  const childrenCount = get(formState, INPUT_NAME);

  return (
    <div className="AdoptionApplicationQuizChildrenCountQuestion">
      <FullPageQuizQuestion
        handleNextClick={handleNextClick}
        icon="pram"
        isValid={isValid}
        title="How many?"
        variant={FULL_PAGE_QUIZ_QUESTION_VARIANTS.WIDE}
      >
        <OptionGroup
          variant={OPTION_GROUP_VARIANTS.CIRCLE}
          isListOnMobile={false}
        >
          {options.map(o => (
            <OptionGroupOption
              type="radio"
              key={o.value}
              inputName={INPUT_NAME}
              value={o.value}
              title={o.title}
              isSelected={childrenCount === o.value}
              onSelect={e => onChange(e.target.value, handleNextClick)}
            />
          ))}
        </OptionGroup>
      </FullPageQuizQuestion>
    </div>
  );
}

QuizChildrenCountQuestion.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formState: PropTypes.object.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired
};
